const images = import.meta.glob("./img/*.webp", { eager: true, import: "default" });

const CATEGORY_GROUPS = {
    "banki-": {
        title: "Банки",
        image: "bank.webp",
        categories: ["banki-vklady-i-sberezheniya", "banki-debetovye-karty", "banki-detskie-offery", "banki-kreditnye-karty", "banki-platezhnye-stikery-platezhnye-aksessuary", "banki-podpiski"],
    },
    bookmakers: { title: "Букмекеры", image: "bookmakers.webp" },
    "vzrosloe-obrazovanie-": {
        title: "Взрослое образование",
        image: "adult_education.webp",
        categories: ["vzrosloe-obrazovanie-kursy", "vzrosloe-obrazovanie-obrazovanie", "vzrosloe-obrazovanie-hobbi"],
    },
    "detskoe-obrazovanie-": {
        title: "Детское образование",
        image: "children_education.webp",
        categories: ["detskoe-obrazovanie-hobbi", "detskoe-obrazovanie-shkolnaya-i-doshkolnaya-programma-razvitie"],
    },
    loans_and_microfinance: { title: "Займы\nи микрозаймы", image: "finance.webp" },
    "zdorove-": {
        title: "Здоровье",
        image: "health_and_medicine.webp",
        categories: ["zdorove-oftalmologiya", "zdorove-flebologiya", "zdorove-chekapy", "zdorove-tovary-dlya-zdorovya-stelki-i-td-syuda-poydut"],
    },
    "zdorove-stomatologii": { title: "Стоматологии", image: "dentistry.webp" },
    internet_services: { title: "Интернет сервисы", image: "online_services.webp" },
    "krasota-": {
        title: "Красота",
        image: "beauty.webp",
        categories: ["krasota-kosmetologiya", "krasota-lazernaya-epilyaciya", "krasota-massazh"],
    },
    "podpiski-i-ekosistemy-": {
        title: "Подписки",
        image: "subscriptions.webp",
        categories: ["podpiski-i-ekosistemy-knigi", "podpiski-i-ekosistemy-kinoteatry", "podpiski-i-ekosistemy-muzyka"],
    },
    "pokupki-i-riteyl-odezhda-i-obuv": { title: "Одежда и обувь", image: "clothes_and_shoes.webp" },
    "pokupki-i-riteyl-parfyumeriya-i-kosmetika": { title: "Парфюмерия и косметика", image: "perfume_and_cosmetics.webp" },
    "pokupki-i-riteyl-stroitelstvo-i-remont": { title: "Все для ремонта", image: "construction_and_repair.webp" },
    "pokupki-i-riteyl-tovary-dlya-doma": { title: "Товары для дома", image: "home.webp" },
    "pokupki-i-riteyl-supermarkety-produkty-dostavki-produktov": { title: "Продукты", image: "supermarket.webp" },
    occult_and_magic_services: { title: "Эзотерика", image: "esoterics.webp" },
    fitness: { title: "Фитнес", image: "fitness.webp" },
};

export const categoryImages = Object.fromEntries(Object.entries(CATEGORY_GROUPS).map(([alias, group]) => [alias, images[`./img/${group.image}`] ?? null]));

export const getCategoryGroupAlias = (alias) => {
    if (typeof alias !== "string") return null;
    if (Object.hasOwn(CATEGORY_GROUPS, alias)) return alias;

    return Object.entries(CATEGORY_GROUPS).find(([, group]) => group.categories?.includes(alias))?.[0] ?? null;
};

export const getCategoryGroups = (categories, offersByCategory) => {
    const groups = new Set();

    categories.forEach((category) => {
        const alias = getCategoryGroupAlias(category.alias);

        if (alias && offersByCategory.get(category.alias)?.length) groups.add(alias);
    });

    return Object.entries(CATEGORY_GROUPS)
        .filter(([alias]) => groups.has(alias))
        .map(([alias, group]) => ({ alias, title: group.title }));
};

export const getCategoryGroupOffers = (alias, offersByCategory) => {
    if (!Object.hasOwn(categoryImages, alias)) return [];

    return (offersByCategory.get("all")?.offers ?? []).filter((offer) => (offer.categories || offer.vendorcategories || []).some((category) => getCategoryGroupAlias(category.alias) === alias));
};

export const getCategoryTitle = (category) => CATEGORY_GROUPS[category.alias]?.title ?? category.title;
